// eslint-disable-next-line import/prefer-default-export
export const moveCaretAtEnd = (e) => {
  const tempValue = e.target.value;
  e.target.value = '';
  e.target.value = tempValue;
};

// allows to store input's value as number rather than string in redux-form for type="number" inputs
// see https://github.com/erikras/redux-form/issues/2940
export const inputParseFn = value => (isNaN(parseInt(value, 10)) ? null : parseInt(value, 10));

export const removeSpecialSymbols = e => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault();

export const allowMaxE = value => value > 10 ** 21 ? value / 100 : value;
